<script>
  import {clearLocalStorage} from '@/utils/common'

  export default {
    mounted() {
      clearLocalStorage()
      window.location = "/login";
    }
  }
</script>
